import { useContext, useEffect, useState } from "react";
import { IMenuItem } from "../../shared/components/menubar/MenuBar";
import { MaintenanceScreenTabs } from "../../shared/util/constant";
import { useHistory, useLocation, Route } from "react-router-dom";
import { Navbar } from "../../components";
import '../../Admin/AdminMenu/AdminMenuBar.scss'
import * as constant from '../../shared/util/constant';
import { useConfirmationModalContext } from "../../shared/components/ModalConfirmationContext";
import AppContext from "../../shared/components/AppContext";
import AgencySetupMain from "../Agency/AgencySetupMain/AgencySetupMain";
import CarrierManagementMain from '../CarrierManagement/CarrierManagementMain';
import Mortgage from '../../Maintenance/Mortgage/Mortgage';
import LookUpTableMain from '../../Maintenance/LookUpTables/LookUpTableMain';
import { AbilityContext } from '../../shared/abilities/AbilityContext';

interface Props {
  isSideBarCollapsed: boolean
}
 
const adminMenuItems: IMenuItem[] = [
  { menuKey: MaintenanceScreenTabs.general.key, menuText: MaintenanceScreenTabs.general.text },
  { menuKey: MaintenanceScreenTabs.company.key, menuText: MaintenanceScreenTabs.company.text },
  { menuKey: MaintenanceScreenTabs.agency.key, menuText: MaintenanceScreenTabs.agency.text }
];
 
const MaintenanceMenuBar = (props: Props) => {
 
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--marginLeftCustomerRow', props.isSideBarCollapsed ? '100px' : '250px')
  }, [props.isSideBarCollapsed]);
 
  const history = useHistory();
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState('');
  const [activeMenuKey, setActiveMenuKey] = useState(null);
  const [activeParentKey, setActiveParentKey] = useState(null);
  const modalContext = useConfirmationModalContext();
  const adminMenuContext = useContext(AppContext);
  const ability = useContext(AbilityContext);

  // Map submenu keys to their maintenance screen privilege fields
  const maintenanceSubmenuPrivilegeMap: Record<string, string> = {
    'carrier-management': constant.MaintenanceScreenPrivileges.Carrier_Management,
    'lookuptables': constant.MaintenanceScreenPrivileges.Lookup_Tables,
    'zipcodes': constant.MaintenanceScreenPrivileges.Zip_Codes,
    'insurance': constant.MaintenanceScreenPrivileges.Insurance,
    'mortgage': constant.MaintenanceScreenPrivileges.Mortgage,
    'autolosspayee': constant.MaintenanceScreenPrivileges.Auto_Loss_Payee,
    'priorinsurancecompany': constant.MaintenanceScreenPrivileges.Prior_Insurance_Company,
  };

  const maintenanceTabPrivilegeMap: Record<string, string> = {
    [MaintenanceScreenTabs.agency.key]: constant.MaintenanceScreenPrivileges.Agency_Setup,
    [MaintenanceScreenTabs.general.key]: constant.MaintenanceScreenPrivileges.General,
    [MaintenanceScreenTabs.company.key]: constant.MaintenanceScreenPrivileges.Company,
  };

  const getMenuVisibility = (menuKey: string): { isVisible: boolean; isDisabled: boolean } => {
    const privilegeField = maintenanceTabPrivilegeMap[menuKey];
    if (!privilegeField) return { isVisible: true, isDisabled: false };
    const canView = ability.can('view', constant.MaintenanceSubject, privilegeField);
    const canRead = ability.can('read', constant.MaintenanceSubject, privilegeField);
    return { isVisible: canView, isDisabled: !canRead };
  };

  const getSubmenuVisibility = (submenuKey: string): { isVisible: boolean; isDisabled: boolean } => {
    const privilegeField = maintenanceSubmenuPrivilegeMap[submenuKey];
    if (!privilegeField) return { isVisible: true, isDisabled: false };
    const canView = ability.can('view', constant.MaintenanceSubject, privilegeField);
    const canRead = ability.can('read', constant.MaintenanceSubject, privilegeField);
    return { isVisible: canView, isDisabled: !canRead };
  };

  // On mount/refresh, determine active menu from URL
  useEffect(() => {
    const path = location.pathname;
    const segment = path.replace('/maintenance/', '').split('/')[0];
    if (!segment) return;
    // Check if segment is a direct menu key
    const directMenu = adminMenuItems.find(m => m.menuKey === segment);
    if (directMenu) {
      setActiveParentKey(segment);
      setCurrentTab(segment);
      return;
    }
    // Check if segment is a submenu key
    for (const menu of adminMenuItems) {
      const submenus = MaintenanceScreenTabs[menu.menuKey]?.submenus || [];
      if (submenus.find(s => s.menuKey === segment)) {
        setActiveParentKey(menu.menuKey);
        setCurrentTab(segment);
        return;
      }
    }
  }, []);

  const clearActiveLinks = () => {
    var tabLinks = document.querySelectorAll(".maintenance-nav-scope .nav-link");
    tabLinks.forEach(function (item) {
      item.classList.remove("active");
    });
  };

  // Apply active class after render based on activeParentKey
  useEffect(() => {
    if (!activeParentKey) return;
    const parentMenu = adminMenuItems.find(m => m.menuKey === activeParentKey);
    if (!parentMenu) return;
    // Remove active from non-matching links only (avoid flicker)
    const navLinks = document.querySelectorAll(".maintenance-nav-scope .nav-link");
    navLinks.forEach((link) => {
      if (link.textContent?.trim() === parentMenu.menuText) {
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    });
  }, [activeParentKey, currentTab]);
 
  const onMenuItemClick = async (menuKey: string, parentKey?: string, event?: any) => {
    const resolvedParent = parentKey || menuKey;
 
    if (!adminMenuContext.formSavedStatus) {
      const result = await modalContext.showConfirmation(constant.CONFIRM_EXIT)
      if (result) {
        setCurrentTab(menuKey);
        setActiveMenuKey(menuKey);
        setActiveParentKey(resolvedParent);
        history.push(`/maintenance/${menuKey}`)
        adminMenuContext.formSavedStatus = true
      }
    }
    else {
      setCurrentTab(menuKey);
      setActiveMenuKey(menuKey);
      setActiveParentKey(resolvedParent);
      history.push(`/maintenance/${menuKey}`)
    }
  }
 
 
  let menusToRender = adminMenuItems;
 
  // useEffect(() => {
  //   if (activeMenuKey && MaintenanceScreenTabs[activeMenuKey]?.submenus) {
  //     setCurrentSubMenus(MaintenanceScreenTabs[activeMenuKey].submenus);
  //   }
  // }, [activeMenuKey]);
  
  let adminMenuBarContent = (
    <div className="maintenance-nav-scope">
    <Navbar
      bg="light"
      variant="light"
      className='py-0'
      navItems={[
        {
          type: 'header',
          label: 'Maintenance',
          className: 'cstHeaderMenu nav-add-new d-none d-md-block cst-header-menu-default',
          iconClassName: 'align-bottom',
          size: 'lg'
        },
        ...menusToRender.filter(menu => {
          const { isVisible } = getMenuVisibility(menu.menuKey);
          return isVisible;
        }).map(menu => {
          const hasSubmenus = MaintenanceScreenTabs[menu.menuKey]?.submenus;
          const submenus = hasSubmenus ? MaintenanceScreenTabs[menu.menuKey].submenus : [];
          const { isDisabled } = getMenuVisibility(menu.menuKey);

          if (hasSubmenus) {
            const visibleSubmenus = submenus.filter(submenu => {
              const { isVisible } = getSubmenuVisibility(submenu.menuKey);
              return isVisible;
            });

            if (visibleSubmenus.length === 0) return null;

            return {
              type: 'link-list',
              label: menu.menuText,
              className: 'cstHeaderMenu nav-add-new d-none d-md-block',
              disabled: isDisabled,
              alignRight: false,
              children: visibleSubmenus.map(submenu => {
                const { isDisabled: isSubmenuDisabled } = getSubmenuVisibility(submenu.menuKey);
                return {
                  type: 'link',
                  label: submenu.menuText,
                  className: `poppins-regular${isSubmenuDisabled ? ' disabled' : ''}`,
                  disabled: isSubmenuDisabled,
                  onClick: isSubmenuDisabled ? undefined : (event) => onMenuItemClick(submenu.menuKey, menu.menuKey, event)
                };
              })
            };
          }

          return {
            type: 'link',
            label: menu.menuText,
            name: menu.menuText,
            className: `cstHeaderMenu nav-add-new d-none d-md-block${isDisabled ? " disabled" : ""}`,
            iconClassName: 'align-bottom',
            size: '10x',
            alignRight: true,
            children: null,
            disabled: isDisabled,
            onClick: isDisabled ? undefined : (event) => onMenuItemClick(menu.menuKey, undefined, event)
          };
        }).filter(Boolean)
      ]} children={""} title={""}    />
    </div>
  );

  return (
<>

{adminMenuBarContent}


<Route
        exact
        path="/maintenance/agency/:groupId?"
        render={() => <AgencySetupMain />}
      />
  <Route
    exact
    path="/maintenance/carrier-management"
    render={() => <CarrierManagementMain />}
          />
    <Route
     exact
     path="/maintenance/mortgage"
     render={() => <Mortgage />}
        />
    <Route
   exact
   path="/maintenance/lookuptables/:tableId?/:tableName?"
   render={() => <LookUpTableMain />}
          />
</>
  );
 
}
 
export default MaintenanceMenuBar